<div class="main-school-details-registration" *ngIf="!schoolDetails">
  <div class="sub-container-school-details-registration">
    <div class="slider">
      <app-slider></app-slider>
    </div>
    <div class="content-for-school-details-registration">
      <div class="help-link-registration">
        <div class="headerbar-right">
          <app-language-dropdown></app-language-dropdown>
          <a target="_blank" class="link-for-contact-registration" data-toggle="modal" data-target="#logout">
            {{ 'logout' | translate }}</a>
        </div>
        </div>
      <div [ngClass]="{
          'sub-container-data-registration': !otpPage,
          'display-none': otpPage
        }">
        <div class="header-of-registration">
          <div class="logo-registration">
            <img *ngIf="brand.id" [src]="brand.logoPath" alt="logo" class="registration-logo-img" />
          </div>
          <div class="school-details-message">
            {{ 'moreAboutInstitute' | translate  }}
          </div>
          <div class="second-school-details-message">
            {{ 'instituteLocated' | translate  }}
          </div>
        </div>
        <div class="school-details-registration-data-collector">
          <div class="school-details-registration-inputs">
            <label for="institute-name-type" [ngClass]="{
                'school-details-registration-label-input':
                  !classInstitutionError,
                'school-details-registration-label-input-error':
                  classInstitutionError
              }">{{ 'instituteType' | translate 
              }}<sup class="mandatory-field">*</sup></label><br />
            <form [formGroup]="form">
              <ng-multiselect-dropdown placeholder="{{ 'placeHolderInstituteType' | translate  }}" id="institute-type"
                [disabled]="loader" autocomplete="off" [settings]="dropdownSettings" [data]="dropdownList"
                formControlName="instituteType" #institutionType (input)="handleDebounceInstituteType(institutionType)">
              </ng-multiselect-dropdown>
              <div *ngIf="
                  form.controls.instituteType.invalid &&
                  (form.controls.instituteType.dirty ||
                    form.controls.instituteType.touched)
                " class="error-message-school-details-registration">
                <span class="error-message">{{
                  'instituteTypeError' | translate 
                  }}</span>
              </div>
            </form>
          </div>
          <div class="school-details-registration-inputs your-name-box">
            <label for="your-name" [ngClass]="{
                'school-details-registration-label-input': !yourNameError,
                'school-details-registration-label-input-error': yourNameError
              }">
              {{ 'yourName' | translate  }}<sup class="mandatory-field">*</sup> </label><br />
            <input type="text" placeholder="{{ 'placeHolderName' | translate  }}" id="your-name" [ngClass]="{
                'input-field-school-details-registration-page': !yourNameError,
                'input-field-school-details-registration-page-error':
                  yourNameError
              }" [disabled]="loader" min="2" maxlength="90" autocomplete="off" #yourNameInput
              (input)="handleDebounceYourName(yourNameInput.value)" [(ngModel)]="formData.yourName" />
            <div *ngIf="yourNameError" class="error-message-school-details-registration">
              <span class="error-message">{{ 'validName' | translate  }}</span>
            </div>
          </div>
          <div class="school-details-registration-inputs">
            <label for="locality" [ngClass]="{
                'school-details-registration-label-input': !localityError,
                'school-details-registration-label-input-error': localityError
              }">
              {{ 'locality' | translate  }}<sup class="mandatory-field">*</sup> </label><br />
            <input type="text" placeholder="{{ 'placeHolderLocality' | translate  }}" id="locality" [disabled]="loader"
              [ngClass]="{
                'input-field-school-details-registration-page': !localityError,
                'input-field-school-details-registration-page-error':
                  localityError
              }" autocomplete="off" minlength="2" maxlength="100" #yourLocalityInput
              (input)="handleDebounceYourLocality(yourLocalityInput.value)" [(ngModel)]="formData.locality" /><br />
            <div *ngIf="localityError" class="error-message-school-details-registration">
              <span class="error-message">{{ 'validLocality' | translate  }}</span>
            </div>
          </div>
          <div class="school-details-registration-inputs">
            <label for="address" [ngClass]="{
                'school-details-registration-label-input': !addressError,
                'school-details-registration-label-input-error': addressError
              }">{{ 'address' | translate  }}<sup class="mandatory-field">*</sup></label><br />
            <input type="text" placeholder="{{ 'placeHolderAddress' | translate  }}" id="address" [disabled]="loader"
              [ngClass]="{
                'input-field-school-details-registration-page': !addressError,
                'input-field-school-details-registration-page-error':
                  addressError
              }" autocomplete="off" minlength="4" maxlength="500" #yourAddressInput
              (input)="handleDebounceYourAddress(yourAddressInput.value)" [(ngModel)]="formData.address" /><br />
            <div *ngIf="addressError" class="error-message-school-details-registration">
              <span class="error-message">{{ 'addressError' | translate  }}</span>
            </div>
          </div>
          <div class="school-details-registration-inputs">
            <label for="pin-code" [ngClass]="{
                'school-details-registration-label-input': !pinCodeError,
                'school-details-registration-label-input-error': pinCodeError
              }">
              {{ 'pinCode' | translate  }}<sup class="mandatory-field">*</sup> </label><br />
            <input type="text" placeholder="{{ 'placeHolderPinCode' | translate  }}" id="pin-code" [disabled]="loader"
              [ngClass]="{
                'input-field-school-details-registration-page': !pinCodeError,
                'input-field-school-details-registration-page-error':
                  pinCodeError
              }" autocomplete="off" minlength="3" maxlength="10" #pinCodeInput
              (input)="handleDebouncePinCode(pinCodeInput.value)" [(ngModel)]="formData.pinCode" pattern="[0-9]"
              (keyup.enter)="onSubmit()" (keydown)="handleKeyDown($event)" /><br />
            <div *ngIf="pinCodeError" class="error-message-school-details-registration">
              <span class="error-message">{{ 'validPinCode' | translate  }}</span>
            </div>
          </div>
          <div class="school-details-registration-inputs">
            <div class="country-state-input-container">
              <div class="country-state-column">
                <label for="country" id="country-name" [ngClass]="{
                    'school-details-registration-label-input': !countryError,
                    'school-details-registration-label-input-error':
                      countryError
                  }">
                  {{ 'country' | translate 
                  }}<sup class="mandatory-field">*</sup> </label><br />
                <input type="text" placeholder="{{ 'placeHolderCountry' | translate  }}" id="country" [ngClass]="{
                    'input-field-school-details-registration-page dropDownCountry':
                      !countryError,
                    'school-details-registration-label-input-error':
                      countryError
                  }" #countryInput (keydown)="preventManualInput($event)" autocomplete="off"
                  [(ngModel)]="formData.countryName" />
                <br />
                <div *ngIf="countryError" class="error-message-school-details-registration">
                  <span class="error-message">{{ 'validCountry' | translate  }}</span>
                </div>
              </div>
              <div class="country-state-column">
                <label for="state" [ngClass]="{
                    'school-details-registration-label-input': !stateError,
                    'school-details-registration-label-input-error': stateError
                  }">
                  {{ 'state' | translate 
                  }}<sup class="mandatory-field">*</sup> </label><br />
                <select id="state" [disabled]="!formData.countryName || loader" [ngClass]="{
                    'input-field-school-details-registration-page': !stateError,
                    'input-field-school-details-registration-page-error':
                      stateError
                  }" autocomplete="off" [(ngModel)]="formData.stateName" name="state">
                  <option value="" disabled selected class="placeholder-option">
                    {{ 'placeHolderSelectState' | translate  }}
                  </option>
                  <option *ngFor="let state of states" [value]="state">
                    {{ state }}
                  </option>
                </select>
                <br />
                <div *ngIf="stateError" class="error-message-school-details-registration">
                  <span class="error-message">{{ 'validState' | translate  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submit-container">
          <button class="registration-continue-btn" [disabled]="loader" (click)="onSubmit()">
            <ng-container *ngIf="loader; else stringContinue">
              <app-button-loader></app-button-loader>
            </ng-container>
            <ng-template #stringContinue>
              {{ 'continue' | translate  }}
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<app-school-registration-under-verification *ngIf="schoolDetails"></app-school-registration-under-verification>
<app-logout-modal></app-logout-modal>